module.exports = __webpack_public_path__ + "static/img_4476-126528f031e290ed693b95996038e2cb.webp";